import type { DataProvider, Record as RARecord } from 'ra-core'
import { UnknownFail } from '@obvious.tech/util/Fail'
import { ResultAsync } from 'neverthrow'
import {
  Entity,
  TEntityName,
  TEntityUntagged,
} from '@obvious.tech/constellation/Entity'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getEntityById<EntityName extends TEntityName = TEntityName>({
  dataProvider,
  id,
  entity,
}: {
  dataProvider: DataProvider
  id: string
  entity: EntityName
}): ResultAsync<TEntityUntagged<EntityName>, UnknownFail> {
  const resource = Entity.getResource(entity)

  return ResultAsync.fromPromise(
    dataProvider.getOne<TEntityUntagged<EntityName> & RARecord>(resource, {
      id,
    }),
    UnknownFail.from,
  ).map(it => it.data)
}
